import { Box, Button, Flex, Text, Tag } from '@pinchenterprisesnpm/friday-ui'
import { Tooltip } from '@pinchenterprisesnpm/friday-ui'
import { TLocationDropdownOption } from '@src/features/shift-post-v2/steps/shift-details-step/components'
import { PROPERTY_STATUS, PROPERTY_STATUS_LABEL } from '@src/models/Property'

interface IFormatOptionLabelProps {
  value: TLocationDropdownOption
}

export const FormatOptionLabel = ({ value }: IFormatOptionLabelProps) => (
  <Tooltip
    isVisible={value.status === PROPERTY_STATUS.PENDING}
    theme="light"
    isInteractive
    placement="bottom"
    appendTo={document.body}
    content={
      <Box>
        <Text>
          Hey! It looks like this location isn&apos;t approved yet. Approval
          typically takes 24 hours, but can be expedited by contacting our
          Support team.
        </Text>
        <Flex justifyContent="flex-end">
          <Button id="intercom_pending_location_bot">Contact Support</Button>
        </Flex>
      </Box>
    }
  >
    <Flex justifyContent="space-between">
      <Text m={0}>{value.label}</Text>
      <Text m={0}>
        <Tag
          isOutlined={true}
          type={
            value.status === PROPERTY_STATUS.APPROVED ? 'primary' : 'warning'
          }
        >
          {value.status === PROPERTY_STATUS.APPROVED
            ? PROPERTY_STATUS_LABEL.APPROVED
            : PROPERTY_STATUS_LABEL.PENDING}
        </Tag>
      </Text>
    </Flex>
  </Tooltip>
)
